/**
 * ODMIANA RZECZOWNIKA PO LICZBIE — polska, trzy formy.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️ POWSTAŁO ZE ZGŁOSZENIA (28.08.2026): „możesz to «os.» rozwinąć do «osób» (oczywiście
 *  z odpowiednimi polskimi tailami 1 osoba, 2 osoby, 20 osób itp.)". Skrót „17 os." czytało się
 *  jak skrót techniczny, a nie jak liczebność grupy ludzi.
 *
 *  ⚠️ NADPISUJE WCZEŚNIEJSZY WYBÓR ZAPISANY W `Planogram.tsx`: tam stoi komentarz „Polska odmiana
 *  ma trzy formy… Ustawienie liczby PO dwukropku jest poprawne dla każdej wartości i nie wymaga
 *  tablicy odmian". To był świadomy unik i dla „kolumn: 3" nadal jest w porządku — ale w zdaniu
 *  „Grupa pracowników · 17 osób" uniku nie ma gdzie zrobić. Skoro odmiana MUSI powstać, to niech
 *  powstanie RAZ i z testem, a nie po trzeciej kopii warunku w JSX-ie.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * ⚠️ REGUŁA NA SETKI, NIE NA SAMĄ KOŃCÓWKĘ — i to jest cały powód, dla którego to jest funkcja,
 * a nie warunek w miejscu użycia. Naiwne „ostatnia cyfra 2–4 → druga forma" psuje NASTOLATKI:
 * dwanaście osób to „12 osób", nie „12 osoby". Trzynaście, czternaście tak samo. Za to 22 i 112
 * już wracają do „osoby", bo o formie decydują dwie ostatnie cyfry, nie jedna.
 */
export type Formy = readonly [jedna: string, dwie: string, wiele: string];

export function odmiana(n: number, formy: Formy): string {
  /**
   * ⚠️ WARTOŚĆ NIECAŁKOWITA I UJEMNA IDZIE W FORMĘ MNOGĄ. Nie powinny się tu zdarzyć (liczymy
   * ludzi i wiersze), ale `NaN` w liczebniku dawałby napis „NaN osoba" — a forma mnoga jest
   * najmniej kłamliwa dla czegokolwiek, co nie jest jednością.
   */
  if (!Number.isInteger(n) || n < 0) return formy[2];
  if (n === 1) return formy[0];
  const ostatnia = n % 10;
  const dwieOstatnie = n % 100;
  if (ostatnia >= 2 && ostatnia <= 4 && !(dwieOstatnie >= 12 && dwieOstatnie <= 14)) return formy[1];
  return formy[2];
}

/** `n` razem z odmienionym rzeczownikiem — „1 osoba", „17 osób". */
export function zLiczba(n: number, formy: Formy): string {
  return `${n} ${odmiana(n, formy)}`;
}

export const OSOBY: Formy = ['osoba', 'osoby', 'osób'];
export const UPRAWNIENIA: Formy = ['uprawnienie', 'uprawnienia', 'uprawnień'];
